module.exports = __webpack_public_path__ + "static/media/salad-image-2.ce15759f.png";